module.exports = __webpack_public_path__ + "static/img/empty.50486467.png";